/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { FilesControllerGetAnnotationsQueryResponse, FilesControllerGetAnnotationsPathParams } from "../../models/filesController/FilesControllerGetAnnotations";

function getFilesControllerGetAnnotationsUrl(id: FilesControllerGetAnnotationsPathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/files/${id}/annotations` as const }  
  return res
}

/**
 * @description Returns all annotations (notes and markups) for the specified file as JSON array. Used by PDF export to generate Markups table.
 * @summary Get file annotations
 * {@link /api/v1/files/:id/annotations}
 */
export async function filesControllerGetAnnotations(id: FilesControllerGetAnnotationsPathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<FilesControllerGetAnnotationsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getFilesControllerGetAnnotationsUrl(id).url.toString(), ... requestConfig })  
  return res.data
}